import { useImperativeHandle } from 'react';

import { type ReceiptInfoBase } from '../../../configs/receipts';
import { Hint } from './UI';

import type { ReceiptCompProps } from '../utils';

export interface PaymentCarrierReceiptInfo extends ReceiptInfoBase {
  type: 'payment_carrier';
}

export const PaymentCarrierReceipt = ({ controlRef }: ReceiptCompProps) => {
  useImperativeHandle(controlRef, () => {
    return {
      submit: async () => {
        return [{ type: 'payment_carrier' }, undefined];
      },
      type: 'payment_carrier',
    };
  });

  return <Hint>發票將依照您於平台內的設定方式開立</Hint>;
};
